import _ from "lodash";
import matcher from "./wizardFieldMatcher";

const ROOT = { root: true };

const getters = {
	sceneNodes: (s, g, rs, rootGetters) => rootGetters["scenes/sceneNodes"],
	targetNode: (s, getters) => _.get(getters.sceneNodes, "commands.0"),
	triggerNode: (s, getters) => _.get(getters.sceneNodes, "ifConditions.0"),
	fromNode: (s, getters) => _.get(getters.sceneNodes, "timeConditions", [])
		.find(condition => condition.operator === ">="),
	toNode: (s, getters) => _.get(getters.sceneNodes, "timeConditions", [])
		.find(condition => condition.operator === "<="),
	orNode: (s, getters) => _.get(getters.sceneNodes, "dateTimeOrConditions.0"),
};

const actions = {
	async create({ dispatch }, { form }) {
		// create scene
		await dispatch("scenes/addScene", form, ROOT);

		// add if condition
		await dispatch("setCondition", { form });

		// add step command
		await dispatch("setCommand", { form });

		// add time constraints
		await dispatch("setTimePeriod", { form });
	},
	async update({ dispatch }, { form, fields = [], scene: { name } }) {
		if (!fields.length) return;
		const promises = [];
		if (fields.includes("trigger")) {
			promises.push(dispatch("setCondition", { form: { ...form, name }, edit: true }));
		}
		if (fields.includes("target")) {
			promises.push(dispatch("setCommand", { form: { ...form, name }, edit: true }));
		}
		if (fields.includes("time")) {
			promises.push(dispatch("setTimePeriod", { form: { ...form, name }, edit: true }));
		}
		await Promise.all(promises);

		if (fields.includes("name")) {
			await dispatch("scenes/renameScene", form, ROOT);
		}

		return true;
	},

	async setCondition({ dispatch, getters }, { form: { trigger, name }, edit = false }) {
		const condition = _.pick(trigger, ["path", "operator", "value"]);
		if (condition.path.includes("events")) {
			condition.operator = "==";
			condition.value = "fired";
		}

		const action = `scenes/${edit ? "update" : "add"}Condition`;
		await dispatch(action, {
			parent: {
				path: `Triggers/${name}`,
			},
			node: getters.triggerNode,
			condition,
		}, ROOT);
	},

	async setCommand({ dispatch, getters }, { form: { target, name }, edit = false }) {
		const action = `scenes/${edit ? "update" : "add"}Step`;
		await dispatch(action, {
			scene: {
				path: `Scenes/${name}`,
			},
			node: getters.targetNode,
			step: {
				order: 1,
				path: target.path,
				args: JSON.stringify(target.args),
			},
		}, ROOT);
	},

	async setTimePeriod({ dispatch, getters, rootGetters }, { form: { time: { from, to }, name }, edit = false }) {
		if (!from || !to) return;

		const oldTimeNodes = _.filter([
			getters.fromNode,
			getters.toNode,
			...(getters.orNode ? [...getters.orNode.children, getters.orNode] : []),
		]);

		const controllerPath = rootGetters["controller/nodes/controller"].path;
		const path = `${controllerPath}/variables/clock/time`;

		const buildCondition = (operator, value) => ({ path, operator, value });

		let parent = { path: `Triggers/${name}` };
		// if it cycles through midnight wrap it in or block
		if (from > to) {
			const orBlock = await dispatch(
				"scenes/addOrBlock",
				{ trigger: parent, when: true },
				ROOT
			);
			parent = { path: orBlock.path() };
		}

		await dispatch(
			`scenes/addCondition`,
			{
				parent,
				condition: buildCondition(">=", from),
			},
			ROOT
		);
		await dispatch(
			`scenes/addCondition`,
			{
				parent,
				condition: buildCondition("<=", to),
			},
			ROOT
		);

		if (edit) {
			for (const node of oldTimeNodes)
				await dispatch("controller/nodes/remove", node, ROOT);
		}
	},

	matchWizard: {
		root: true,
		handler(ctx, parsedScene) {
			let match = matcher("trigger", parsedScene);
			return {
				wizard: "trigger",
				match
			};
		}
	}
};

export default {
	namespaced: true,
	getters,
	actions,
};
